import Icon from '../components/Icon.vue'

Icon.register({
  'audio-description': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M162.9 238.7l8.8 30.7h-25.6l9-30.7c1.3-4.4 2.7-10 3.9-15.2 1.2 5.3 2.6 10.8 3.9 15.2zM329.4 206.6c28.7 0 46.2 16.8 46.2 49 0 32.1-16.4 49.8-46.2 49.8h-14.5v-98.8h14.5zM512 112v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48zM245.5 336.1l-57.1-168c-1.5-4.5-6.6-8.1-11.4-8.1h-35.9c-4.7 0-9.8 3.6-11.4 8.1l-57.1 168c-2.6 7.8 3.1 15.9 11.4 15.9h29.1c5 0 10.2-3.9 11.5-8.7l8.6-29.9h51.4l8.8 30c1.4 4.8 6.6 8.6 11.5 8.6v0h29.2c8.2 0 14-8.1 11.4-15.9zM430.2 255.6c0-59-37.9-95.6-99-95.6h-57.4c-6.6 0-12 5.4-12 12v168c0 6.6 5.4 12 12 12h57.4c61 0 99-36.9 99-96.4z'
      }
    ]
  }
})
